export default "__VITE_ASSET___z9MGd7i__"